module.exports = __webpack_public_path__ + "img/elsalvador.6f1b39fd.svg";